import { Paper, ScrollArea, Button, ThemeIcon, Center, Loader, useMantineTheme, Stack, Text } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { IconMapPin, IconTrash } from "@tabler/icons-react";
import cx from "clsx";

import { ListLocationDto } from "../../models/location.models";
import { useFilteredLocations } from "../../functions/location-filter.hooks";
import { useSearch } from "../../functions/SearchBox.hook";
import { NoSearchResults } from "../Shared/NoSearchResults";
import classes from './LocationList.module.css';

interface LocationListProps {
	locations?: ListLocationDto[] | undefined;
	isLoading?: boolean;
	selectedLocation?: ListLocationDto | null;
	setSelectedLocation?: (location: ListLocationDto | null) => void;
}
export const LocationList = ({ locations, isLoading, selectedLocation, setSelectedLocation }: LocationListProps) => {
	const theme = useMantineTheme();
	const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`, true);
	const { query, setQuery } = useSearch();
	const { filteredLocations, showNoResults } = useFilteredLocations(locations || []);

	if (isLoading) return <Paper withBorder p={0} radius="md" style={{ overflow: 'hidden' }}>
			<ScrollArea type={isMobile ? "never" : "scroll"} style={{ height: isMobile ? 'unset' : 'calc(100vh - 160px)', minHeight: isMobile ? 'calc(100vh - 150px)' : 'calc(100vh - 160px)' }} >
				<Center>
					<Loader size="sm" mt="lg" />
				</Center>
			</ScrollArea>
		</Paper>

	const handleLocationSelect = (e: React.MouseEvent<HTMLAnchorElement>, location: ListLocationDto): void => {
		e.preventDefault();
		setSelectedLocation?.(location);
	}

	return <>
		<Paper withBorder p={0} radius="md" style={{ overflow: 'hidden' }}>
			<ScrollArea type={isMobile ? "never" : "hover"} style={{ height: isMobile ? 'unset' : 'calc(100vh - 160px)', minHeight: isMobile ? 'calc(100vh - 150px)' : 'calc(100vh - 160px)' }} >
				{filteredLocations?.map(location => (
					<Button key={location.LocationId}
						component="a"
						href={`/locations/${location.LocationId}`}
						onClick={(e) => handleLocationSelect(e, location)}
						className={cx(classes['location-list-item'], { [classes['selected-item']]: selectedLocation?.LocationId === location.LocationId })}
						leftSection={
							<ThemeIcon radius="xl"
								color={location.Deleted ? "red" : "blue"}
								size="xl"
								style={{ border: `1px solid var(--mantine-color-default-border)` }}
								variant="light"
							>
								{!location.Deleted ? <IconMapPin size={24} /> : <IconTrash size={24} />}
							</ThemeIcon>
						}
					>
						<Text c={location.Deleted ? "dimmed" : ""}>{location.Title}</Text>
					</Button>
				))}
				{showNoResults && <NoSearchResults searchType="locations" query={query} setQuery={setQuery} />}
				{locations?.length === 0 && <>
					<Stack align="center" justify="center" mt="xl" px="sm">
						<ThemeIcon size={100} radius={100} variant="light" color="gray">
							<IconMapPin size={60} />
						</ThemeIcon>
						<Text style={{ textAlign: 'center' }} lineClamp={1} c="dimmed">No locations have been created yet.</Text>
					</Stack>
				</>}
			</ScrollArea>
		</Paper>
	</>
}
